import LogoMark from "./LogoMark";

export default function Footer() {
  return (
    <footer className="border-t border-[rgba(255,255,255,0.06)]">
      <div className="fp-section !py-16">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-10">
          <div>
            <div className="flex items-center gap-2.5">
              <LogoMark className="h-6 w-auto" />
              <span className="text-base font-bold tracking-tight">fundprints</span>
            </div>
            <p className="mt-3 font-mono text-xs text-[#5A6272]">Smart money leaves prints.</p>
            <p className="mt-1 font-mono text-xs text-[#3A4152]">Crowding intelligence for your stocks and funds.</p>
          </div>
          <nav className="flex flex-wrap gap-x-8 gap-y-3">
            {[
              ["/how", "How it works"],
              ["/books", "The Book"],
              ["/radar", "Divergence Radar"],
              ["#receipts", "Receipts"],
              ["#pricing", "Pricing"],
            ].map(([href, label]) => (
              <a key={href} href={href} data-testid={`footer-link-${href.slice(1)}`} className="text-sm text-[#8B93A3] hover:text-[#E8EBF0] transition-colors">
                {label}
              </a>
            ))}
            <a href="/methodology" data-testid="footer-link-methodology" className="text-sm text-[#8B93A3] hover:text-[#E8EBF0] transition-colors">
              Methodology
            </a>
            <a href="/privacy" data-testid="footer-link-privacy" className="text-sm text-[#8B93A3] hover:text-[#E8EBF0] transition-colors">
              Privacy
            </a>
            <a href="/terms" data-testid="footer-link-terms" className="text-sm text-[#8B93A3] hover:text-[#E8EBF0] transition-colors">
              Terms
            </a>
            <a href="https://x.com/fundprints" target="_blank" rel="noreferrer" data-testid="footer-link-x"
               className="text-sm text-[#2BD97C] hover:text-[#E8EBF0] transition-colors">
              Follow on X ↗
            </a>
          </nav>
        </div>
        <div data-testid="footer-disclaimer" className="mt-12 pt-8 border-t border-[rgba(255,255,255,0.06)]">
          <p className="font-mono text-[11px] text-[#5A6272] leading-relaxed max-w-4xl">
            Fundprints identifies evidence, never instructions. Nothing on this site is investment
            advice or a recommendation to buy or sell any security. Performance shown is a
            model book tracked live in the open, recorded in real time since December 2023.
            Past performance does not guarantee
            future results. Crowded and Fading describe the evidence, not your decision. Sourced
            exclusively from public, mandatory
            disclosures and listed options data.
          </p>
          <p className="mt-6 font-mono text-[11px] text-[#3A4152]">© 2026 Fundprints. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
